
import { Container } from '../../components/radiant-components/container'
import { Footer } from '../../components/radiant-components/footer'
import { Gradient } from '../../components/radiant-components/gradient'
import { Navbar } from '../../components/radiant-components/navbar'
import { useNavigate } from 'react-router-dom'
import { useRef  } from 'react'

function Hero({ GotoPage, handleScroll }) {
  return (
    <div className="relative">
      <Gradient className="absolute inset-2 bottom-0 rounded-4xl ring-1 ring-black/5 ring-inset" />
      <Container className="relative">
        <Navbar GotoPage={GotoPage} />
        <div className="pt-16 pb-24 sm:pt-24 sm:pb-32 md:pt-32 md:pb-48">
          <h1 className="font-display text-6xl/[0.9] font-medium tracking-tight text-balance text-gray-950 sm:text-8xl/[0.8] md:text-9xl/[0.8]">
            Contact Us
          </h1>
          <p className="mt-8 max-w-4xl text-xl/7 font-medium text-gray-950/75 sm:text-2xl/8">
            Whether you're ready to get started, want to understand how we work, or simply have a few questions, we're here for it. No bots, no fluff- just real people ready to help you get more from your product feed.
          </p>
        </div>
      </Container>
    </div>
  )
}

function DarkBentoSection() {
  return (
    <></>
  )
}

export default function ContactUs() {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const GotoPage = (pageName, message = "") => {
      if(pageName !== "" && pageName !== "#") {
          setTimeout(() => {
          navigate(`${pageName}`, {state: { message: message }});
          }, 200); // Optional delay for UX smoothness
      }
  };
  const smoothScroll = (targetY, duration = 600) => {
    const startY = window.scrollY;
    const diff = targetY - startY;
    let start;

    const step = timestamp => {
      if (!start) start = timestamp;
      const time = timestamp - start;
      const percent = Math.min(time / duration, 1);

      // Ease-in-out
      const ease = percent < 0.5
        ? 2 * percent * percent
        : -1 + (4 - 2 * percent) * percent;

      window.scrollTo(0, startY + diff * ease);

      if (time < duration) {
        requestAnimationFrame(step);
      }
    };

  requestAnimationFrame(step);
};
  const handleScroll = () => {
    const top = sectionRef.current.offsetTop;
    smoothScroll(top, 900); // 900ms
  };
  return (
    <div className="overflow-hidden">
      <Hero GotoPage={GotoPage} handleScroll={handleScroll}/>
      <main>
        <Container className="mt-10">
        </Container>
        <DarkBentoSection />
      </main>
      <Footer GotoPage={GotoPage}/>
    </div>
  )
}
